// extracted by mini-css-extract-plugin
export var author = "quoted-text-module--author--15f2f";
export var content = "quoted-text-module--content--5c7e7";
export var pipe = "quoted-text-module--pipe--2100f";
export var quote = "quoted-text-module--quote--21858";
export var quoteImg = "quoted-text-module--quoteImg--463f2";
export var quoteImgBottom = "quoted-text-module--quoteImgBottom--4bdda";
export var title = "quoted-text-module--title--4c050";
export var wrapper = "quoted-text-module--wrapper--87866";